// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"d281893d","94":"3819cc28","95":"9535afac","98":"972c59ce","120":"27a358cd","127":"ec378caf","442":"12756ab2","455":"4d1a2f12","488":"eca7d72b","613":"492e70d1","726":"0535edd4","851":"5d014996","919":"80f1fc9a"}[chunkId] + ".chunk.js";
};